import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  fetchMeta,
  setMetaForEdit,
  selectLoading,
  updateMeta,
  selectMetaForEditing,
} from "features/admin/Meta/metasAdminSlice";
import AdminForm from "../AdminForm";

const EditMeta = () => {
  const [progress, setProgress] = useState(0);
  const { id } = useParams();
  const dispatch = useDispatch();
  const meta = useSelector(selectMetaForEditing);
  const isLoading = useSelector(selectLoading);
  const navigate = useNavigate();
  useEffect(() => {
    !isLoading && dispatch(fetchMeta(id));
    return () => {
      dispatch(setMetaForEdit(undefined));
    };
  }, [id]);

  const onSubmit = (obj: any) => {
    const data = { id: id, data: obj };
    dispatch(
      updateMeta(data, (event) => {
        setProgress(Math.round((100 * event.loaded) / event.total));
      })
    );
    navigate(-1);
  };
  return (
    <AdminForm
      formTitle="Промяна на мета информация"
      onSubmit={onSubmit}
      field={meta}
      progress={progress}
    />
  );
};

export default EditMeta;
